module.exports = __webpack_public_path__ + "static/media/fwd.51e43fae.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/fwd.png
// module id = 790
// module chunks = 0